<div class="contact-form--container">
  <form
    [formGroup]="contactForm"
    autocomplete="off"
    class="card form-container shadow-sm"
    (ngSubmit)="submit()"
  >
    <h2 class="text-center">Contact</h2>
    <label for="name" class="form-label">Name</label>
    <input type="text" id="name" formControlName="name" class="form-control" />
    <app-form-error *ngIf="nameNoValid"></app-form-error>

    <label for="reason" class="form-label">Reason</label>
    <input
      type="text"
      id="reason"
      formControlName="reason"
      class="form-control"
    />
    <app-form-error *ngIf="reasonNoValid"></app-form-error>

    <label for="message" class="form-label">Message</label>
    <textarea
      name="message"
      id="message"
      cols="30"
      rows="10"
      formControlName="message"
      class="form-control"
    ></textarea>
    <app-form-error *ngIf="messageNoValid"></app-form-error>

    <div class="btn-container">
      <button type="submit" class="btn btn-outline-dark">Submit</button>
    </div>
  </form>
</div>
